(() => {
  if (window.comicPlaceholderRotationReady) return;
  window.comicPlaceholderRotationReady = true;
  const easternDate = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
  });
  const anchor = Date.UTC(2026, 10, 2);
  function rotationIndex(date, count) {
    const parts = Object.fromEntries(easternDate.formatToParts(date).map(part => [part.type, part.value]));
    const localDay = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    const weeks = Math.floor((localDay - anchor) / 604800000);
    return ((weeks % count) + count) % count;
  }
  function update() {
    document.querySelectorAll('img[data-comic-weekly-rotation]').forEach(image => {
      try {
        const images = JSON.parse(image.dataset.comicWeeklyRotation);
        if (images.length !== 5) return;
        const index = rotationIndex(new Date(), images.length);
        if (image.dataset.comicWeekIndex === String(index)) return;
        const selected = images[index];
        if (!selected.src || !selected.srcset || !selected.width || !selected.height) return;
        image.width = selected.width;
        image.height = selected.height;
        image.srcset = selected.srcset;
        image.src = selected.src;
        image.dataset.comicWeekIndex = String(index);
      } catch (_) {
        return;
      }
    });
  }
  update();
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  window.addEventListener('pageshow', update);
  window.setInterval(update, 60000);
})();
